// extracted by mini-css-extract-plugin
module.exports = {"recommender":"xd-z"};